// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_mj-0";
export var animationContainer = "_mj-1";
export var itemPrice = "_mj-a";
export var itemizedContent = "_mj-9";
export var itemizedHeader = "_mj-7";
export var itemizedRow = "_mj-8";
export var itemizedSection = "_mj-6";
export var modalContent = "_mj-2";
export var orderName = "_mj-3";
export var refundOption = "_mj-4";
export var refundOptionsContainer = "_mj-5";
export var shippingLabel = "_mj-b";
export var totalRow = "_mj-c";